export default class ObjectHelper {
  static removeEmptyKeys(obj: {[k: string]: any}): void {
    Object.keys(obj).forEach((k) => (!obj[k] || obj[k] === '' || obj[k] === undefined || obj[k] === null) && delete obj[k])
  }

  static updateByObject(obj1: {[k: string]: any}, obj2: {[k: string]: any}): void {
    Object.keys(obj1).forEach((key) => {
      if (obj2[key] !== undefined) {
        if (obj1[key] && typeof obj1[key] === 'object') {
          this.updateByObject(obj1[key], obj2[key]);
        } else {
          obj1[key] = obj2[key];
        }
      }
    });
  }

  static clone(obj: {[k: string]: any}): object {
    return JSON.parse(JSON.stringify(obj));
  }
}
